/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OAuthCompleteOutCalendar = typeof OAuthCompleteOutCalendar[keyof typeof OAuthCompleteOutCalendar];


export const OAuthCompleteOutCalendar = {
  connected: 'connected',
  reconnected: 'reconnected',
  error: 'error',
} as const;
